import { format, parse } from "date-fns";

export const convertDateToISO = (inputDate: string): string => {
  const parsedDate = parse(inputDate, "dd/MM/yyyy", new Date());
  return format(parsedDate, "yyyy-MM-dd");
};

export const splitNumber = (total: number, chunkSize: number): number[] => [
  ...Array(Math.floor(total / chunkSize)).fill(chunkSize),
  ...(total % chunkSize ? [total % chunkSize] : []),
];
